module.exports = __webpack_public_path__ + "img/house-slide.4003f668.png";